module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-285.2936be0b.jpg";